import React, { useState, useRef, useEffect } from "react";
import "./Dropdown.css";

const Dropdown = ({ values = [], selectedValue, onSelectValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (value) => {
    onSelectValue(getValue(value));
    setIsOpen(false);
    setSearchQuery("");
  };

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const getLabel = (item) => (typeof item === "object" ? item.label : item);
  const getValue = (item) => (typeof item === "object" ? item.value : item);

  const filteredValues = values.filter((val) =>
    getLabel(val).toLowerCase().includes(searchQuery.toLowerCase())
  );

  const selectedObject = values.find((v) => getValue(v) === selectedValue);

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div className="dropdown-label-area">
        <div className="dropdown-toggle" onClick={toggleDropdown}>
          <div
            className={`selected-info ${selectedObject ? "" : "placeholder"}`}
          >
            <span>
              {selectedObject ? getLabel(selectedObject) : "Select an option"}
            </span>
          </div>
          <span className="arrow">
            <i
              className="fa fa-angle-down"
              style={{ opacity: selectedObject ? 1 : 0.5 }}
            ></i>
          </span>
        </div>
      </div>

      {isOpen && (
        <div className="dropdown-menu">
          <input
            type="text"
            className="search-input"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <ul className="dropdown-list">
            {filteredValues.length > 0 ? (
              filteredValues.map((val) => (
                <li
                  key={getValue(val)}
                  className="dropdown-item"
                  onClick={() => handleSelect(val)}
                >
                  {getLabel(val)}
                </li>
              ))
            ) : (
              <li className="dropdown-item no-result">No matches found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
